import es from './es.json'

import items_es from './cusco_story.json'


es.items = items_es

export default { es }
